import React, { ButtonHTMLAttributes } from 'react';

import { SwitchContainer } from './styles';

interface SwitchProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  checked: boolean;
}

export const Switch: React.FC<SwitchProps> = ({ onClick, checked }) => {
  return (
    <SwitchContainer checked={checked} onClick={onClick}>
      <div />
    </SwitchContainer>
  );
};
